import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ButtonModule} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {CheckboxModule} from 'primeng/checkbox';
import {DatePickerModule} from 'primeng/datepicker';
import {DialogModule} from 'primeng/dialog';
import {PaginatorModule} from 'primeng/paginator';
import {PopoverModule} from 'primeng/popover';
import {SelectModule} from 'primeng/select';
import {SelectAutoDisplayFirstDirective} from '@app/directives/select-auto-display-first.directive';
import {ToastModule} from 'primeng/toast';
import {NotificationIndicatorComponent} from './notification-indicator.component';
import {NotificationCountBadgeComponent} from './notification-count-badge.component';

@NgModule({
    declarations: [
        NotificationIndicatorComponent,
        NotificationCountBadgeComponent
    ],
    imports: [
        CommonModule, FormsModule, ButtonModule, TooltipModule, CheckboxModule, DatePickerModule, DialogModule,
        PaginatorModule, PopoverModule, SelectModule, SelectAutoDisplayFirstDirective, ToastModule
    ],
    exports: [
        NotificationIndicatorComponent,
        NotificationCountBadgeComponent
    ]
})
export class SharedNotificationIndicatorModule {
}
